import React from 'react';

const steps = [
  'Connect Shopify',
  'Configure Analysis',
  'Run Analysis',
  'View Results',
];

const StepProgress = ({ step }) => (
  <div className="mb-10">
    <div className="flex justify-between mb-4">
      {steps.map((label, index) => {
        const current = index + 1 === step;
        const complete = index + 1 < step;
        return (
          <div key={index} className="step flex flex-col items-center">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center font-bold mb-1 ${
                complete
                  ? 'bg-green-500 text-white'
                  : current
                  ? 'bg-indigo-600 text-white'
                  : 'bg-gray-200 text-gray-600'
              }`}
            >
              {index + 1}
            </div>
            <span
              className={`text-sm font-medium ${
                current ? 'text-indigo-600' : complete ? 'text-green-600' : 'text-gray-500'
              }`}
            >
              {label}
            </span>
          </div>
        );
      })}
    </div>
    <div className="w-full bg-gray-200 rounded-full h-2">
      <div
        className="progress-bar bg-indigo-600 rounded-full h-2"
        style={{ width: `${(step - 1) * 33.3 + 25}%`,maxWidth:"100%" }}
      ></div>
      {/* <div class="w-full bg-gray-200 rounded-full h-2">
                <div class="progress-bar bg-indigo-600 rounded-full h-2" style={{width: "25%"}}></div>
            </div> */}
    </div>
  </div>
);

export default StepProgress;
